export const worldAbi = [
  {
    name: "transferAmounts",
    type: "function",
    stateMutability: "nonpayable",
    inputs: [
      {
        type: "bytes32",
        name: "caller",
      },
      {
        type: "bytes32",
        name: "from",
      },
      {
        type: "bytes32",
        name: "to",
      },
      {
        type: "tuple[]",
        name: "amounts",
        components: [
          {
            type: "uint16",
            name: "slot",
          },
          {
            type: "uint16",
            name: "amount",
          },
        ],
      },
      {
        type: "bytes",
        name: "extraData",
      },
    ],
    outputs: [],
  },
] as const;

export const systemAbis = [
  {
    name: "activate",
    type: "function",
    stateMutability: "nonpayable",
    inputs: [
      {
        type: "bytes32",
        name: "entityId",
      },
    ],
    outputs: [],
  },
  {
    name: "activatePlayer",
    type: "function",
    stateMutability: "nonpayable",
    inputs: [
      {
        type: "address",
        name: "playerAddress",
      },
    ],
    outputs: [],
  },
  {
    name: "buildAndAttachProgram",
    type: "function",
    stateMutability: "nonpayable",
    inputs: [
      {
        type: "bytes32",
        name: "caller",
      },
      {
        type: "uint96",
        name: "coord",
      },
      {
        type: "uint16",
        name: "slot",
      },
      {
        type: "bytes32",
        name: "program",
      },
      {
        type: "bytes",
        name: "buildExtraData",
      },
      {
        type: "bytes",
        name: "attachExtraData",
      },
    ],
    outputs: [
      {
        type: "bytes32",
      },
    ],
  },
  {
    name: "buildAndAttachProgramWithOrientation",
    type: "function",
    stateMutability: "nonpayable",
    inputs: [
      {
        type: "bytes32",
        name: "caller",
      },
      {
        type: "uint96",
        name: "coord",
      },
      {
        type: "uint16",
        name: "slot",
      },
      {
        type: "uint8",
        name: "orientation",
      },
      {
        type: "bytes32",
        name: "program",
      },
      {
        type: "bytes",
        name: "buildExtraData",
      },
      {
        type: "bytes",
        name: "attachExtraData",
      },
    ],
    outputs: [
      {
        type: "bytes32",
      },
    ],
  },
  {
    name: "jumpBuildAndAttachProgram",
    type: "function",
    stateMutability: "nonpayable",
    inputs: [
      {
        type: "bytes32",
        name: "caller",
      },
      {
        type: "uint16",
        name: "slot",
      },
      {
        type: "bytes32",
        name: "program",
      },
      {
        type: "bytes",
        name: "buildExtraData",
      },
      {
        type: "bytes",
        name: "attachExtraData",
      },
    ],
    outputs: [
      {
        type: "bytes32",
      },
    ],
  },
  {
    name: "jumpBuildWithOrientationAndAttachProgram",
    type: "function",
    stateMutability: "nonpayable",
    inputs: [
      {
        type: "bytes32",
        name: "caller",
      },
      {
        type: "uint16",
        name: "slot",
      },
      {
        type: "uint8",
        name: "orientation",
      },
      {
        type: "bytes32",
        name: "program",
      },
      {
        type: "bytes",
        name: "buildExtraData",
      },
      {
        type: "bytes",
        name: "attachExtraData",
      },
    ],
    outputs: [
      {
        type: "bytes32",
      },
    ],
  },
  {
    name: "removeDeadPlayerFromBed",
    type: "function",
    stateMutability: "nonpayable",
    inputs: [
      {
        type: "bytes32",
        name: "player",
      },
      {
        type: "uint96",
        name: "dropCoord",
      },
    ],
    outputs: [],
  },
  {
    name: "sleep",
    type: "function",
    stateMutability: "nonpayable",
    inputs: [
      {
        type: "bytes32",
        name: "caller",
      },
      {
        type: "bytes32",
        name: "bed",
      },
      {
        type: "bytes",
        name: "extraData",
      },
    ],
    outputs: [],
  },
  {
    name: "wakeup",
    type: "function",
    stateMutability: "nonpayable",
    inputs: [
      {
        type: "bytes32",
        name: "caller",
      },
      {
        type: "uint96",
        name: "spawnCoord",
      },
      {
        type: "bytes",
        name: "extraData",
      },
    ],
    outputs: [],
  },
  {
    name: "fillBucket",
    type: "function",
    stateMutability: "nonpayable",
    inputs: [
      {
        type: "bytes32",
        name: "caller",
      },
      {
        type: "uint96",
        name: "waterCoord",
      },
      {
        type: "uint16",
        name: "bucketSlot",
      },
    ],
    outputs: [],
  },
  {
    name: "wetFarmland",
    type: "function",
    stateMutability: "nonpayable",
    inputs: [
      {
        type: "bytes32",
        name: "caller",
      },
      {
        type: "uint96",
        name: "coord",
      },
      {
        type: "uint16",
        name: "bucketSlot",
      },
    ],
    outputs: [],
  },
  {
    name: "build",
    type: "function",
    stateMutability: "nonpayable",
    inputs: [
      {
        type: "bytes32",
        name: "caller",
      },
      {
        type: "uint96",
        name: "coord",
      },
      {
        type: "uint16",
        name: "slot",
      },
      {
        type: "bytes",
        name: "extraData",
      },
    ],
    outputs: [
      {
        type: "bytes32",
      },
    ],
  },
  {
    name: "buildWithOrientation",
    type: "function",
    stateMutability: "nonpayable",
    inputs: [
      {
        type: "bytes32",
        name: "caller",
      },
      {
        type: "uint96",
        name: "coord",
      },
      {
        type: "uint16",
        name: "slot",
      },
      {
        type: "uint8",
        name: "orientation",
      },
      {
        type: "bytes",
        name: "extraData",
      },
    ],
    outputs: [
      {
        type: "bytes32",
      },
    ],
  },
  {
    name: "jumpBuild",
    type: "function",
    stateMutability: "nonpayable",
    inputs: [
      {
        type: "bytes32",
        name: "caller",
      },
      {
        type: "uint16",
        name: "slot",
      },
      {
        type: "bytes",
        name: "extraData",
      },
    ],
    outputs: [
      {
        type: "bytes32",
      },
    ],
  },
  {
    name: "jumpBuildWithOrientation",
    type: "function",
    stateMutability: "nonpayable",
    inputs: [
      {
        type: "bytes32",
        name: "caller",
      },
      {
        type: "uint16",
        name: "slot",
      },
      {
        type: "uint8",
        name: "orientation",
      },
      {
        type: "bytes",
        name: "extraData",
      },
    ],
    outputs: [
      {
        type: "bytes32",
      },
    ],
  },
  {
    name: "craft",
    type: "function",
    stateMutability: "nonpayable",
    inputs: [
      {
        type: "bytes32",
        name: "caller",
      },
      {
        type: "bytes32",
        name: "recipeId",
      },
      {
        type: "tuple[]",
        name: "inputs",
        components: [
          {
            type: "uint16",
            name: "slot",
          },
          {
            type: "uint16",
            name: "amount",
          },
        ],
      },
    ],
    outputs: [],
  },
  {
    name: "craftWithStation",
    type: "function",
    stateMutability: "nonpayable",
    inputs: [
      {
        type: "bytes32",
        name: "caller",
      },
      {
        type: "bytes32",
        name: "station",
      },
      {
        type: "bytes32",
        name: "recipeId",
      },
      {
        type: "tuple[]",
        name: "inputs",
        components: [
          {
            type: "uint16",
            name: "slot",
          },
          {
            type: "uint16",
            name: "amount",
          },
        ],
      },
    ],
    outputs: [],
  },
  {
    name: "till",
    type: "function",
    stateMutability: "nonpayable",
    inputs: [
      {
        type: "bytes32",
        name: "caller",
      },
      {
        type: "uint96",
        name: "coord",
      },
      {
        type: "uint16",
        name: "toolSlot",
      },
    ],
    outputs: [],
  },
  {
    name: "eat",
    type: "function",
    stateMutability: "nonpayable",
    inputs: [
      {
        type: "bytes32",
        name: "caller",
      },
      {
        type: "tuple",
        name: "slotAmount",
        components: [
          {
            type: "uint16",
            name: "slot",
          },
          {
            type: "uint16",
            name: "amount",
          },
        ],
      },
    ],
    outputs: [],
  },
  {
    name: "addFragment",
    type: "function",
    stateMutability: "nonpayable",
    inputs: [
      {
        type: "bytes32",
        name: "caller",
      },
      {
        type: "bytes32",
        name: "forceField",
      },
      {
        type: "uint96",
        name: "refFragmentCoord",
      },
      {
        type: "uint96",
        name: "fragmentCoord",
      },
      {
        type: "bytes",
        name: "extraData",
      },
    ],
    outputs: [],
  },
  {
    name: "computeBoundaryFragments",
    type: "function",
    stateMutability: "view",
    inputs: [
      {
        type: "bytes32",
        name: "forceField",
      },
      {
        type: "uint96",
        name: "fragmentCoord",
      },
    ],
    outputs: [
      {
        type: "uint96[]",
      },
    ],
  },
  {
    name: "removeFragment",
    type: "function",
    stateMutability: "nonpayable",
    inputs: [
      {
        type: "bytes32",
        name: "caller",
      },
      {
        type: "bytes32",
        name: "forceField",
      },
      {
        type: "uint96",
        name: "fragmentCoord",
      },
      {
        type: "uint8[]",
        name: "boundaryIdx",
      },
      {
        type: "uint8[]",
        name: "parents",
      },
      {
        type: "bytes",
        name: "extraData",
      },
    ],
    outputs: [],
  },
  {
    name: "validateSpanningTree",
    type: "function",
    stateMutability: "pure",
    inputs: [
      {
        type: "uint96[]",
        name: "boundary",
      },
      {
        type: "uint8[]",
        name: "boundaryIdx",
      },
      {
        type: "uint8[]",
        name: "parents",
      },
    ],
    outputs: [
      {
        type: "bool",
      },
    ],
  },
  {
    name: "addGuardian",
    type: "function",
    stateMutability: "nonpayable",
    inputs: [
      {
        type: "address",
        name: "guardian",
      },
    ],
    outputs: [],
  },
  {
    name: "pause",
    type: "function",
    stateMutability: "nonpayable",
    inputs: [],
    outputs: [],
  },
  {
    name: "removeGuardian",
    type: "function",
    stateMutability: "nonpayable",
    inputs: [
      {
        type: "address",
        name: "guardian",
      },
    ],
    outputs: [],
  },
  {
    name: "unpause",
    type: "function",
    stateMutability: "nonpayable",
    inputs: [],
    outputs: [],
  },
  {
    name: "hitForceField",
    type: "function",
    stateMutability: "nonpayable",
    inputs: [
      {
        type: "bytes32",
        name: "caller",
      },
      {
        type: "uint96",
        name: "coord",
      },
      {
        type: "uint16",
        name: "toolSlot",
      },
    ],
    outputs: [],
  },
  {
    name: "hitForceField",
    type: "function",
    stateMutability: "nonpayable",
    inputs: [
      {
        type: "bytes32",
        name: "caller",
      },
      {
        type: "uint96",
        name: "coord",
      },
    ],
    outputs: [],
  },
  {
    name: "drop",
    type: "function",
    stateMutability: "nonpayable",
    inputs: [
      {
        type: "bytes32",
        name: "caller",
      },
      {
        type: "tuple[]",
        name: "slots",
        components: [
          {
            type: "uint16",
            name: "slot",
          },
          {
            type: "uint16",
            name: "amount",
          },
        ],
      },
      {
        type: "uint96",
        name: "coord",
      },
    ],
    outputs: [],
  },
  {
    name: "pickup",
    type: "function",
    stateMutability: "nonpayable",
    inputs: [
      {
        type: "bytes32",
        name: "caller",
      },
      {
        type: "tuple[]",
        name: "slotTransfers",
        components: [
          {
            type: "uint16",
            name: "slotFrom",
          },
          {
            type: "uint16",
            name: "slotTo",
          },
          {
            type: "uint16",
            name: "amount",
          },
        ],
      },
      {
        type: "uint96",
        name: "coord",
      },
    ],
    outputs: [],
  },
  {
    name: "pickupAll",
    type: "function",
    stateMutability: "nonpayable",
    inputs: [
      {
        type: "bytes32",
        name: "caller",
      },
      {
        type: "uint96",
        name: "coord",
      },
    ],
    outputs: [],
  },
  {
    name: "fuelMachine",
    type: "function",
    stateMutability: "nonpayable",
    inputs: [
      {
        type: "bytes32",
        name: "caller",
      },
      {
        type: "bytes32",
        name: "machine",
      },
      {
        type: "tuple[]",
        name: "slots",
        components: [
          {
            type: "uint16",
            name: "slot",
          },
          {
            type: "uint16",
            name: "amount",
          },
        ],
      },
      {
        type: "bytes",
        name: "extraData",
      },
    ],
    outputs: [],
  },
  {
    name: "getRandomOreType",
    type: "function",
    stateMutability: "view",
    inputs: [
      {
        type: "uint96",
        name: "coord",
      },
    ],
    outputs: [
      {
        type: "uint16",
      },
    ],
  },
  {
    name: "mine",
    type: "function",
    stateMutability: "nonpayable",
    inputs: [
      {
        type: "bytes32",
        name: "caller",
      },
      {
        type: "uint96",
        name: "coord",
      },
      {
        type: "bytes",
        name: "extraData",
      },
    ],
    outputs: [
      {
        type: "bytes32",
      },
    ],
  },
  {
    name: "mine",
    type: "function",
    stateMutability: "nonpayable",
    inputs: [
      {
        type: "bytes32",
        name: "caller",
      },
      {
        type: "uint96",
        name: "coord",
      },
      {
        type: "uint16",
        name: "toolSlot",
      },
      {
        type: "bytes",
        name: "extraData",
      },
    ],
    outputs: [
      {
        type: "bytes32",
      },
    ],
  },
  {
    name: "mineUntilDestroyed",
    type: "function",
    stateMutability: "nonpayable",
    inputs: [
      {
        type: "bytes32",
        name: "caller",
      },
      {
        type: "uint96",
        name: "coord",
      },
      {
        type: "bytes",
        name: "extraData",
      },
    ],
    outputs: [],
  },
  {
    name: "mineUntilDestroyed",
    type: "function",
    stateMutability: "nonpayable",
    inputs: [
      {
        type: "bytes32",
        name: "caller",
      },
      {
        type: "uint96",
        name: "coord",
      },
      {
        type: "uint16",
        name: "toolSlot",
      },
      {
        type: "bytes",
        name: "extraData",
      },
    ],
    outputs: [],
  },
  {
    name: "chunkCommit",
    type: "function",
    stateMutability: "nonpayable",
    inputs: [
      {
        type: "bytes32",
        name: "caller",
      },
      {
        type: "uint96",
        name: "chunkCoord",
      },
    ],
    outputs: [],
  },
  {
    name: "growSeed",
    type: "function",
    stateMutability: "nonpayable",
    inputs: [
      {
        type: "bytes32",
        name: "caller",
      },
      {
        type: "uint96",
        name: "coord",
      },
    ],
    outputs: [],
  },
  {
    name: "respawnResource",
    type: "function",
    stateMutability: "nonpayable",
    inputs: [
      {
        type: "uint256",
        name: "blockNumber",
      },
      {
        type: "uint16",
        name: "resourceType",
      },
    ],
    outputs: [],
  },
  {
    name: "attachProgram",
    type: "function",
    stateMutability: "nonpayable",
    inputs: [
      {
        type: "bytes32",
        name: "caller",
      },
      {
        type: "bytes32",
        name: "target",
      },
      {
        type: "bytes32",
        name: "program",
      },
      {
        type: "bytes",
        name: "extraData",
      },
    ],
    outputs: [],
  },
  {
    name: "detachProgram",
    type: "function",
    stateMutability: "nonpayable",
    inputs: [
      {
        type: "bytes32",
        name: "caller",
      },
      {
        type: "bytes32",
        name: "target",
      },
      {
        type: "bytes",
        name: "extraData",
      },
    ],
    outputs: [],
  },
  {
    name: "updateProgram",
    type: "function",
    stateMutability: "nonpayable",
    inputs: [
      {
        type: "bytes32",
        name: "caller",
      },
      {
        type: "bytes32",
        name: "target",
      },
      {
        type: "bytes32",
        name: "newProgram",
      },
      {
        type: "bytes",
        name: "extraData",
      },
    ],
    outputs: [],
  },
  {
    name: "getRandomSpawnChunk",
    type: "function",
    stateMutability: "view",
    inputs: [
      {
        type: "uint256",
        name: "blockNumber",
      },
      {
        type: "address",
        name: "sender",
      },
    ],
    outputs: [
      {
        type: "uint96",
        name: "chunk",
      },
    ],
  },
  {
    name: "getRandomSpawnCoord",
    type: "function",
    stateMutability: "view",
    inputs: [
      {
        type: "uint256",
        name: "blockNumber",
      },
      {
        type: "address",
        name: "sender",
      },
    ],
    outputs: [
      {
        type: "uint96",
        name: "spawnCoord",
      },
    ],
  },
  {
    name: "isValidSpawn",
    type: "function",
    stateMutability: "view",
    inputs: [
      {
        type: "uint96",
        name: "spawnCoord",
      },
    ],
    outputs: [
      {
        type: "bool",
      },
    ],
  },
  {
    name: "randomSpawn",
    type: "function",
    stateMutability: "nonpayable",
    inputs: [
      {
        type: "uint256",
        name: "blockNumber",
      },
      {
        type: "uint96",
        name: "spawnCoord",
      },
    ],
    outputs: [
      {
        type: "bytes32",
      },
    ],
  },
  {
    name: "spawn",
    type: "function",
    stateMutability: "nonpayable",
    inputs: [
      {
        type: "bytes32",
        name: "spawnTile",
      },
      {
        type: "uint96",
        name: "spawnCoord",
      },
      {
        type: "uint128",
        name: "spawnEnergy",
      },
      {
        type: "bytes",
        name: "extraData",
      },
    ],
    outputs: [
      {
        type: "bytes32",
      },
    ],
  },
  {
    name: "exploreChunk",
    type: "function",
    stateMutability: "nonpayable",
    inputs: [
      {
        type: "uint96",
        name: "chunkCoord",
      },
      {
        type: "bytes",
        name: "chunkData",
      },
      {
        type: "bytes32[]",
        name: "merkleProof",
      },
    ],
    outputs: [],
  },
  {
    name: "exploreRegionEnergy",
    type: "function",
    stateMutability: "nonpayable",
    inputs: [
      {
        type: "uint96",
        name: "regionCoord",
      },
      {
        type: "uint32",
        name: "vegetationCount",
      },
      {
        type: "bytes32[]",
        name: "merkleProof",
      },
    ],
    outputs: [],
  },
  {
    name: "PesosImplLib_CallingFromRootSystem",
    type: "error",
    inputs: [],
  },
  {
    name: "WorldConsumer_CallerHasNoNamespaceAccess",
    type: "error",
    inputs: [
      {
        type: "address",
        name: "worldAddress",
      },
      {
        type: "bytes14",
        name: "namespace",
      },
      {
        type: "address",
        name: "caller",
      },
    ],
  },
  {
    name: "WorldConsumer_CallerIsNotNamespaceOwner",
    type: "error",
    inputs: [
      {
        type: "address",
        name: "worldAddress",
      },
      {
        type: "bytes14",
        name: "namespace",
      },
      {
        type: "address",
        name: "caller",
      },
    ],
  },
  {
    name: "WorldConsumer_CallerIsNotWorld",
    type: "error",
    inputs: [
      {
        type: "address",
        name: "worldAddress",
      },
      {
        type: "address",
        name: "caller",
      },
    ],
  },
  {
    name: "WorldConsumer_RootNamespaceNotAllowed",
    type: "error",
    inputs: [
      {
        type: "address",
        name: "worldAddress",
      },
    ],
  },
  {
    name: "WorldConsumer_ValueNotAllowed",
    type: "error",
    inputs: [
      {
        type: "address",
        name: "worldAddress",
      },
    ],
  },
  {
    name: "_msgSender",
    type: "function",
    stateMutability: "view",
    inputs: [],
    outputs: [
      {
        type: "address",
      },
    ],
  },
  {
    name: "_msgValue",
    type: "function",
    stateMutability: "view",
    inputs: [],
    outputs: [
      {
        type: "uint256",
      },
    ],
  },
  {
    name: "appConfigURI",
    type: "function",
    stateMutability: "pure",
    inputs: [
      {
        type: "bytes32",
      },
    ],
    outputs: [
      {
        type: "string",
      },
    ],
  },
  {
    name: "onAttachProgram",
    type: "function",
    stateMutability: "view",
    inputs: [
      {
        type: "tuple",
        name: "ctx",
        components: [
          {
            type: "bytes32",
            name: "caller",
          },
          {
            type: "bytes32",
            name: "target",
          },
          {
            type: "bytes",
            name: "extraData",
          },
        ],
      },
    ],
    outputs: [],
  },
  {
    name: "onDetachProgram",
    type: "function",
    stateMutability: "view",
    inputs: [
      {
        type: "tuple",
        name: "ctx",
        components: [
          {
            type: "bytes32",
            name: "caller",
          },
          {
            type: "bytes32",
            name: "target",
          },
          {
            type: "bytes",
            name: "extraData",
          },
        ],
      },
    ],
    outputs: [],
  },
  {
    name: "onTransfer",
    type: "function",
    stateMutability: "nonpayable",
    inputs: [
      {
        type: "tuple",
        name: "ctx",
        components: [
          {
            type: "bytes32",
            name: "caller",
          },
          {
            type: "bytes32",
            name: "target",
          },
          {
            type: "tuple[]",
            name: "deposits",
            components: [
              {
                type: "bytes32",
                name: "entityId",
              },
              {
                type: "uint16",
                name: "objectType",
              },
              {
                type: "uint16",
                name: "amount",
              },
            ],
          },
          {
            type: "tuple[]",
            name: "withdrawals",
            components: [
              {
                type: "bytes32",
                name: "entityId",
              },
              {
                type: "uint16",
                name: "objectType",
              },
              {
                type: "uint16",
                name: "amount",
              },
            ],
          },
          {
            type: "bytes",
            name: "extraData",
          },
        ],
      },
    ],
    outputs: [],
  },
  {
    name: "move",
    type: "function",
    stateMutability: "nonpayable",
    inputs: [
      {
        type: "bytes32",
        name: "caller",
      },
      {
        type: "uint96[]",
        name: "newCoords",
      },
    ],
    outputs: [],
  },
  {
    name: "moveDirections",
    type: "function",
    stateMutability: "nonpayable",
    inputs: [
      {
        type: "bytes32",
        name: "caller",
      },
      {
        type: "uint8[]",
        name: "directions",
      },
    ],
    outputs: [],
  },
  {
    name: "moveDirectionsPacked",
    type: "function",
    stateMutability: "nonpayable",
    inputs: [
      {
        type: "bytes32",
        name: "caller",
      },
      {
        type: "uint256",
        name: "packed",
      },
    ],
    outputs: [],
  },
  {
    name: "transfer",
    type: "function",
    stateMutability: "nonpayable",
    inputs: [
      {
        type: "bytes32",
        name: "caller",
      },
      {
        type: "bytes32",
        name: "from",
      },
      {
        type: "bytes32",
        name: "to",
      },
      {
        type: "tuple[]",
        name: "transfers",
        components: [
          {
            type: "uint16",
            name: "slotFrom",
          },
          {
            type: "uint16",
            name: "slotTo",
          },
          {
            type: "uint16",
            name: "amount",
          },
        ],
      },
      {
        type: "bytes",
        name: "extraData",
      },
    ],
    outputs: [],
  },
  {
    name: "transferAmounts",
    type: "function",
    stateMutability: "nonpayable",
    inputs: [
      {
        type: "bytes32",
        name: "caller",
      },
      {
        type: "bytes32",
        name: "from",
      },
      {
        type: "bytes32",
        name: "to",
      },
      {
        type: "tuple[]",
        name: "amounts",
        components: [
          {
            type: "uint16",
            name: "slot",
          },
          {
            type: "uint16",
            name: "amount",
          },
        ],
      },
      {
        type: "bytes",
        name: "extraData",
      },
    ],
    outputs: [],
  },
  {
    name: "PesosImplLib_CallingFromRootSystem",
    type: "error",
    inputs: [],
  },
  {
    name: "WorldConsumer_CallerHasNoNamespaceAccess",
    type: "error",
    inputs: [
      {
        type: "address",
        name: "worldAddress",
      },
      {
        type: "bytes14",
        name: "namespace",
      },
      {
        type: "address",
        name: "caller",
      },
    ],
  },
  {
    name: "WorldConsumer_CallerIsNotNamespaceOwner",
    type: "error",
    inputs: [
      {
        type: "address",
        name: "worldAddress",
      },
      {
        type: "bytes14",
        name: "namespace",
      },
      {
        type: "address",
        name: "caller",
      },
    ],
  },
  {
    name: "WorldConsumer_CallerIsNotWorld",
    type: "error",
    inputs: [
      {
        type: "address",
        name: "worldAddress",
      },
      {
        type: "address",
        name: "caller",
      },
    ],
  },
  {
    name: "WorldConsumer_RootNamespaceNotAllowed",
    type: "error",
    inputs: [
      {
        type: "address",
        name: "worldAddress",
      },
    ],
  },
  {
    name: "WorldConsumer_ValueNotAllowed",
    type: "error",
    inputs: [
      {
        type: "address",
        name: "worldAddress",
      },
    ],
  },
  {
    name: "_msgSender",
    type: "function",
    stateMutability: "view",
    inputs: [],
    outputs: [
      {
        type: "address",
      },
    ],
  },
  {
    name: "_msgValue",
    type: "function",
    stateMutability: "view",
    inputs: [],
    outputs: [
      {
        type: "uint256",
      },
    ],
  },
  {
    name: "appConfigURI",
    type: "function",
    stateMutability: "pure",
    inputs: [
      {
        type: "bytes32",
      },
    ],
    outputs: [
      {
        type: "string",
      },
    ],
  },
  {
    name: "onAttachProgram",
    type: "function",
    stateMutability: "nonpayable",
    inputs: [
      {
        type: "tuple",
        name: "ctx",
        components: [
          {
            type: "bytes32",
            name: "caller",
          },
          {
            type: "bytes32",
            name: "target",
          },
          {
            type: "bytes",
            name: "extraData",
          },
        ],
      },
    ],
    outputs: [],
  },
  {
    name: "onDetachProgram",
    type: "function",
    stateMutability: "nonpayable",
    inputs: [
      {
        type: "tuple",
        name: "ctx",
        components: [
          {
            type: "bytes32",
            name: "caller",
          },
          {
            type: "bytes32",
            name: "target",
          },
          {
            type: "bytes",
            name: "extraData",
          },
        ],
      },
    ],
    outputs: [],
  },
  {
    name: "onTransfer",
    type: "function",
    stateMutability: "nonpayable",
    inputs: [
      {
        type: "tuple",
        name: "ctx",
        components: [
          {
            type: "bytes32",
            name: "caller",
          },
          {
            type: "bytes32",
            name: "target",
          },
          {
            type: "tuple[]",
            name: "deposits",
            components: [
              {
                type: "bytes32",
                name: "entityId",
              },
              {
                type: "uint16",
                name: "objectType",
              },
              {
                type: "uint16",
                name: "amount",
              },
            ],
          },
          {
            type: "tuple[]",
            name: "withdrawals",
            components: [
              {
                type: "bytes32",
                name: "entityId",
              },
              {
                type: "uint16",
                name: "objectType",
              },
              {
                type: "uint16",
                name: "amount",
              },
            ],
          },
          {
            type: "bytes",
            name: "extraData",
          },
        ],
      },
    ],
    outputs: [],
  },
  {
    name: "WorldConsumer_CallerHasNoNamespaceAccess",
    type: "error",
    inputs: [
      {
        type: "address",
        name: "worldAddress",
      },
      {
        type: "bytes14",
        name: "namespace",
      },
      {
        type: "address",
        name: "caller",
      },
    ],
  },
  {
    name: "WorldConsumer_CallerIsNotNamespaceOwner",
    type: "error",
    inputs: [
      {
        type: "address",
        name: "worldAddress",
      },
      {
        type: "bytes14",
        name: "namespace",
      },
      {
        type: "address",
        name: "caller",
      },
    ],
  },
  {
    name: "WorldConsumer_CallerIsNotWorld",
    type: "error",
    inputs: [
      {
        type: "address",
        name: "worldAddress",
      },
      {
        type: "address",
        name: "caller",
      },
    ],
  },
  {
    name: "WorldConsumer_RootNamespaceNotAllowed",
    type: "error",
    inputs: [
      {
        type: "address",
        name: "worldAddress",
      },
    ],
  },
  {
    name: "WorldConsumer_ValueNotAllowed",
    type: "error",
    inputs: [
      {
        type: "address",
        name: "worldAddress",
      },
    ],
  },
  {
    name: "_msgSender",
    type: "function",
    stateMutability: "view",
    inputs: [],
    outputs: [
      {
        type: "address",
      },
    ],
  },
  {
    name: "_msgValue",
    type: "function",
    stateMutability: "view",
    inputs: [],
    outputs: [
      {
        type: "uint256",
      },
    ],
  },
  {
    name: "contentURI",
    type: "function",
    stateMutability: "view",
    inputs: [
      {
        type: "bytes32",
      },
      {
        type: "bytes32",
        name: "target",
      },
      {
        type: "bytes",
      },
    ],
    outputs: [
      {
        type: "string",
      },
    ],
  },
  {
    name: "onAttachProgram",
    type: "function",
    stateMutability: "view",
    inputs: [
      {
        type: "tuple",
        name: "ctx",
        components: [
          {
            type: "bytes32",
            name: "caller",
          },
          {
            type: "bytes32",
            name: "target",
          },
          {
            type: "bytes",
            name: "extraData",
          },
        ],
      },
    ],
    outputs: [],
  },
  {
    name: "onDetachProgram",
    type: "function",
    stateMutability: "view",
    inputs: [
      {
        type: "tuple",
        name: "ctx",
        components: [
          {
            type: "bytes32",
            name: "caller",
          },
          {
            type: "bytes32",
            name: "target",
          },
          {
            type: "bytes",
            name: "extraData",
          },
        ],
      },
    ],
    outputs: [],
  },
  {
    name: "setAdmin",
    type: "function",
    stateMutability: "nonpayable",
    inputs: [
      {
        type: "address",
        name: "admin",
      },
    ],
    outputs: [],
  },
  {
    name: "setAllowedProgram",
    type: "function",
    stateMutability: "nonpayable",
    inputs: [
      {
        type: "bytes32",
        name: "program",
      },
      {
        type: "bool",
        name: "allowed",
      },
    ],
    outputs: [],
  },
  {
    name: "setBlueprintChunk",
    type: "function",
    stateMutability: "nonpayable",
    inputs: [
      {
        type: "uint96",
        name: "chunkCoord",
      },
      {
        type: "bytes",
        name: "chunkData",
      },
    ],
    outputs: [],
  },
  {
    name: "setCityCouncilMember",
    type: "function",
    stateMutability: "nonpayable",
    inputs: [
      {
        type: "address",
        name: "player",
      },
      {
        type: "bool",
        name: "isMember",
      },
    ],
    outputs: [],
  },
  {
    name: "setGlobalShopFee",
    type: "function",
    stateMutability: "nonpayable",
    inputs: [
      {
        type: "uint256",
        name: "feeNumerator",
      },
      {
        type: "address",
        name: "receiver",
      },
    ],
    outputs: [],
  },
  {
    name: "setIncentive",
    type: "function",
    stateMutability: "nonpayable",
    inputs: [
      {
        type: "uint8",
        name: "action",
      },
      {
        type: "bytes32",
        name: "dataHash",
      },
      {
        type: "int256",
        name: "tokenAmount",
      },
      {
        type: "int256",
        name: "reputationAmount",
      },
    ],
    outputs: [],
  },
  {
    name: "setTreasury",
    type: "function",
    stateMutability: "nonpayable",
    inputs: [
      {
        type: "address",
        name: "treasuryAddress",
      },
    ],
    outputs: [],
  },
  {
    name: "DEFAULT_CLAIM_PERIOD",
    type: "function",
    stateMutability: "view",
    inputs: [],
    outputs: [
      {
        type: "uint32",
      },
    ],
  },
  {
    name: "DEFAULT_CLAIM_PRICE",
    type: "function",
    stateMutability: "view",
    inputs: [],
    outputs: [
      {
        type: "uint256",
      },
    ],
  },
  {
    name: "DEFAULT_GRACE_PERIOD",
    type: "function",
    stateMutability: "view",
    inputs: [],
    outputs: [
      {
        type: "uint32",
      },
    ],
  },
  {
    name: "DEFAULT_RENEWAL_PRICE",
    type: "function",
    stateMutability: "view",
    inputs: [],
    outputs: [
      {
        type: "uint256",
      },
    ],
  },
  {
    name: "setShopClaim",
    type: "function",
    stateMutability: "nonpayable",
    inputs: [
      {
        type: "bytes32",
        name: "chest",
      },
      {
        type: "uint256",
        name: "claimPrice",
      },
      {
        type: "uint256",
        name: "renewalPrice",
      },
      {
        type: "uint32",
        name: "claimPeriod",
      },
      {
        type: "uint32",
        name: "gracePeriod",
      },
    ],
    outputs: [],
  },
  {
    name: "setShopClaim",
    type: "function",
    stateMutability: "nonpayable",
    inputs: [
      {
        type: "bytes32",
        name: "chest",
      },
    ],
    outputs: [],
  },
  {
    name: "setShopRenewalPrice",
    type: "function",
    stateMutability: "nonpayable",
    inputs: [
      {
        type: "bytes32",
        name: "chest",
      },
      {
        type: "uint256",
        name: "renewalPrice",
      },
    ],
    outputs: [],
  },
  {
    name: "setTextSignContent",
    type: "function",
    stateMutability: "nonpayable",
    inputs: [
      {
        type: "bytes32",
        name: "target",
      },
      {
        type: "string",
        name: "content",
      },
    ],
    outputs: [],
  },
  {
    name: "PesosImplLib_CallingFromRootSystem",
    type: "error",
    inputs: [],
  },
  {
    name: "claimShop",
    type: "function",
    stateMutability: "nonpayable",
    inputs: [
      {
        type: "bytes32",
        name: "chest",
      },
      {
        type: "string",
        name: "name",
      },
      {
        type: "uint256",
        name: "expectedClaimPrice",
      },
      {
        type: "uint128",
        name: "expectedClaimPeriod",
      },
    ],
    outputs: [],
  },
  {
    name: "renewClaim",
    type: "function",
    stateMutability: "nonpayable",
    inputs: [
      {
        type: "bytes32",
        name: "chest",
      },
    ],
    outputs: [],
  },
  {
    name: "setShopEntries",
    type: "function",
    stateMutability: "nonpayable",
    inputs: [
      {
        type: "bytes32",
        name: "chest",
      },
      {
        type: "uint16[]",
        name: "objectTypes",
      },
      {
        type: "tuple[]",
        name: "shopEntries",
        components: [
          {
            type: "uint256",
            name: "buyPrice",
          },
          {
            type: "uint256",
            name: "sellPrice",
          },
          {
            type: "uint16",
            name: "maxBuyAmount",
          },
          {
            type: "uint16",
            name: "maxSellAmount",
          },
        ],
      },
    ],
    outputs: [],
  },
  {
    name: "setShopName",
    type: "function",
    stateMutability: "nonpayable",
    inputs: [
      {
        type: "bytes32",
        name: "chest",
      },
      {
        type: "string",
        name: "name",
      },
    ],
    outputs: [],
  },
  {
    name: "PesosImplLib_CallingFromRootSystem",
    type: "error",
    inputs: [],
  },
  {
    name: "WorldConsumer_CallerHasNoNamespaceAccess",
    type: "error",
    inputs: [
      {
        type: "address",
        name: "worldAddress",
      },
      {
        type: "bytes14",
        name: "namespace",
      },
      {
        type: "address",
        name: "caller",
      },
    ],
  },
  {
    name: "WorldConsumer_CallerIsNotNamespaceOwner",
    type: "error",
    inputs: [
      {
        type: "address",
        name: "worldAddress",
      },
      {
        type: "bytes14",
        name: "namespace",
      },
      {
        type: "address",
        name: "caller",
      },
    ],
  },
  {
    name: "WorldConsumer_CallerIsNotWorld",
    type: "error",
    inputs: [
      {
        type: "address",
        name: "worldAddress",
      },
      {
        type: "address",
        name: "caller",
      },
    ],
  },
  {
    name: "WorldConsumer_RootNamespaceNotAllowed",
    type: "error",
    inputs: [
      {
        type: "address",
        name: "worldAddress",
      },
    ],
  },
  {
    name: "WorldConsumer_ValueNotAllowed",
    type: "error",
    inputs: [
      {
        type: "address",
        name: "worldAddress",
      },
    ],
  },
  {
    name: "_msgSender",
    type: "function",
    stateMutability: "view",
    inputs: [],
    outputs: [
      {
        type: "address",
      },
    ],
  },
  {
    name: "_msgValue",
    type: "function",
    stateMutability: "view",
    inputs: [],
    outputs: [
      {
        type: "uint256",
      },
    ],
  },
  {
    name: "appConfigURI",
    type: "function",
    stateMutability: "pure",
    inputs: [
      {
        type: "bytes32",
      },
    ],
    outputs: [
      {
        type: "string",
      },
    ],
  },
  {
    name: "onAttachProgram",
    type: "function",
    stateMutability: "nonpayable",
    inputs: [
      {
        type: "tuple",
        name: "ctx",
        components: [
          {
            type: "bytes32",
            name: "caller",
          },
          {
            type: "bytes32",
            name: "target",
          },
          {
            type: "bytes",
            name: "extraData",
          },
        ],
      },
    ],
    outputs: [],
  },
  {
    name: "onDetachProgram",
    type: "function",
    stateMutability: "nonpayable",
    inputs: [
      {
        type: "tuple",
        name: "ctx",
        components: [
          {
            type: "bytes32",
            name: "caller",
          },
          {
            type: "bytes32",
            name: "target",
          },
          {
            type: "bytes",
            name: "extraData",
          },
        ],
      },
    ],
    outputs: [],
  },
  {
    name: "onTransfer",
    type: "function",
    stateMutability: "nonpayable",
    inputs: [
      {
        type: "tuple",
        name: "ctx",
        components: [
          {
            type: "bytes32",
            name: "caller",
          },
          {
            type: "bytes32",
            name: "target",
          },
          {
            type: "tuple[]",
            name: "deposits",
            components: [
              {
                type: "bytes32",
                name: "entityId",
              },
              {
                type: "uint16",
                name: "objectType",
              },
              {
                type: "uint16",
                name: "amount",
              },
            ],
          },
          {
            type: "tuple[]",
            name: "withdrawals",
            components: [
              {
                type: "bytes32",
                name: "entityId",
              },
              {
                type: "uint16",
                name: "objectType",
              },
              {
                type: "uint16",
                name: "amount",
              },
            ],
          },
          {
            type: "bytes",
            name: "extraData",
          },
        ],
      },
    ],
    outputs: [],
  },
  {
    name: "DefaultProgramSystemLib_CallingFromRootSystem",
    type: "error",
    inputs: [],
  },
  {
    name: "PesosImplLib_CallingFromRootSystem",
    type: "error",
    inputs: [],
  },
  {
    name: "WorldConsumer_CallerHasNoNamespaceAccess",
    type: "error",
    inputs: [
      {
        type: "address",
        name: "worldAddress",
      },
      {
        type: "bytes14",
        name: "namespace",
      },
      {
        type: "address",
        name: "caller",
      },
    ],
  },
  {
    name: "WorldConsumer_CallerIsNotNamespaceOwner",
    type: "error",
    inputs: [
      {
        type: "address",
        name: "worldAddress",
      },
      {
        type: "bytes14",
        name: "namespace",
      },
      {
        type: "address",
        name: "caller",
      },
    ],
  },
  {
    name: "WorldConsumer_CallerIsNotWorld",
    type: "error",
    inputs: [
      {
        type: "address",
        name: "worldAddress",
      },
      {
        type: "address",
        name: "caller",
      },
    ],
  },
  {
    name: "WorldConsumer_RootNamespaceNotAllowed",
    type: "error",
    inputs: [
      {
        type: "address",
        name: "worldAddress",
      },
    ],
  },
  {
    name: "WorldConsumer_ValueNotAllowed",
    type: "error",
    inputs: [
      {
        type: "address",
        name: "worldAddress",
      },
    ],
  },
  {
    name: "_msgSender",
    type: "function",
    stateMutability: "view",
    inputs: [],
    outputs: [
      {
        type: "address",
      },
    ],
  },
  {
    name: "_msgValue",
    type: "function",
    stateMutability: "view",
    inputs: [],
    outputs: [
      {
        type: "uint256",
      },
    ],
  },
  {
    name: "onAddFragment",
    type: "function",
    stateMutability: "view",
    inputs: [
      {
        type: "tuple",
        name: "ctx",
        components: [
          {
            type: "bytes32",
            name: "caller",
          },
          {
            type: "bytes32",
            name: "target",
          },
          {
            type: "bytes32",
            name: "added",
          },
          {
            type: "bytes",
            name: "extraData",
          },
        ],
      },
    ],
    outputs: [],
  },
  {
    name: "onAttachProgram",
    type: "function",
    stateMutability: "nonpayable",
    inputs: [
      {
        type: "tuple",
        name: "ctx",
        components: [
          {
            type: "bytes32",
            name: "caller",
          },
          {
            type: "bytes32",
            name: "target",
          },
          {
            type: "bytes",
            name: "extraData",
          },
        ],
      },
    ],
    outputs: [],
  },
  {
    name: "onBuild",
    type: "function",
    stateMutability: "nonpayable",
    inputs: [
      {
        type: "tuple",
        name: "ctx",
        components: [
          {
            type: "bytes32",
            name: "caller",
          },
          {
            type: "bytes32",
            name: "target",
          },
          {
            type: "uint16",
            name: "objectType",
          },
          {
            type: "uint96",
            name: "coord",
          },
          {
            type: "bytes",
            name: "extraData",
          },
        ],
      },
    ],
    outputs: [],
  },
  {
    name: "onDetachProgram",
    type: "function",
    stateMutability: "nonpayable",
    inputs: [
      {
        type: "tuple",
        name: "ctx",
        components: [
          {
            type: "bytes32",
            name: "caller",
          },
          {
            type: "bytes32",
            name: "target",
          },
          {
            type: "bytes",
            name: "extraData",
          },
        ],
      },
    ],
    outputs: [],
  },
  {
    name: "onFuel",
    type: "function",
    stateMutability: "nonpayable",
    inputs: [
      {
        type: "tuple",
        name: "ctx",
        components: [
          {
            type: "bytes32",
            name: "caller",
          },
          {
            type: "bytes32",
            name: "target",
          },
          {
            type: "uint16",
            name: "fuelAmount",
          },
          {
            type: "bytes",
            name: "extraData",
          },
        ],
      },
    ],
    outputs: [],
  },
  {
    name: "onHit",
    type: "function",
    stateMutability: "nonpayable",
    inputs: [
      {
        type: "tuple",
        name: "ctx",
        components: [
          {
            type: "bytes32",
            name: "caller",
          },
          {
            type: "bytes32",
            name: "target",
          },
          {
            type: "uint128",
            name: "damage",
          },
          {
            type: "bytes",
            name: "extraData",
          },
        ],
      },
    ],
    outputs: [],
  },
  {
    name: "onMine",
    type: "function",
    stateMutability: "nonpayable",
    inputs: [
      {
        type: "tuple",
        name: "ctx",
        components: [
          {
            type: "bytes32",
            name: "caller",
          },
          {
            type: "bytes32",
            name: "target",
          },
          {
            type: "uint16",
            name: "objectType",
          },
          {
            type: "uint96",
            name: "coord",
          },
          {
            type: "bytes",
            name: "extraData",
          },
        ],
      },
    ],
    outputs: [],
  },
  {
    name: "onRemoveFragment",
    type: "function",
    stateMutability: "view",
    inputs: [
      {
        type: "tuple",
        name: "ctx",
        components: [
          {
            type: "bytes32",
            name: "caller",
          },
          {
            type: "bytes32",
            name: "target",
          },
          {
            type: "bytes32",
            name: "removed",
          },
          {
            type: "bytes",
            name: "extraData",
          },
        ],
      },
    ],
    outputs: [],
  },
  {
    name: "setupAccessGroup",
    type: "function",
    stateMutability: "nonpayable",
    inputs: [],
    outputs: [],
  },
  {
    name: "validateProgram",
    type: "function",
    stateMutability: "view",
    inputs: [
      {
        type: "tuple",
        name: "ctx",
        components: [
          {
            type: "bytes32",
            name: "caller",
          },
          {
            type: "bytes32",
            name: "target",
          },
          {
            type: "bytes32",
            name: "programmed",
          },
          {
            type: "bytes32",
            name: "program",
          },
          {
            type: "bytes",
            name: "extraData",
          },
        ],
      },
    ],
    outputs: [],
  },
  {
    name: "ERC20InsufficientAllowance",
    type: "error",
    inputs: [
      {
        type: "address",
        name: "spender",
      },
      {
        type: "uint256",
        name: "allowance",
      },
      {
        type: "uint256",
        name: "needed",
      },
    ],
  },
  {
    name: "ERC20InsufficientBalance",
    type: "error",
    inputs: [
      {
        type: "address",
        name: "sender",
      },
      {
        type: "uint256",
        name: "balance",
      },
      {
        type: "uint256",
        name: "needed",
      },
    ],
  },
  {
    name: "ERC20InvalidApprover",
    type: "error",
    inputs: [
      {
        type: "address",
        name: "approver",
      },
    ],
  },
  {
    name: "ERC20InvalidReceiver",
    type: "error",
    inputs: [
      {
        type: "address",
        name: "receiver",
      },
    ],
  },
  {
    name: "ERC20InvalidSender",
    type: "error",
    inputs: [
      {
        type: "address",
        name: "sender",
      },
    ],
  },
  {
    name: "ERC20InvalidSpender",
    type: "error",
    inputs: [
      {
        type: "address",
        name: "spender",
      },
    ],
  },
  {
    name: "WorldConsumer_CallerHasNoNamespaceAccess",
    type: "error",
    inputs: [
      {
        type: "address",
        name: "worldAddress",
      },
      {
        type: "bytes14",
        name: "namespace",
      },
      {
        type: "address",
        name: "caller",
      },
    ],
  },
  {
    name: "WorldConsumer_CallerIsNotNamespaceOwner",
    type: "error",
    inputs: [
      {
        type: "address",
        name: "worldAddress",
      },
      {
        type: "bytes14",
        name: "namespace",
      },
      {
        type: "address",
        name: "caller",
      },
    ],
  },
  {
    name: "WorldConsumer_CallerIsNotWorld",
    type: "error",
    inputs: [
      {
        type: "address",
        name: "worldAddress",
      },
      {
        type: "address",
        name: "caller",
      },
    ],
  },
  {
    name: "WorldConsumer_RootNamespaceNotAllowed",
    type: "error",
    inputs: [
      {
        type: "address",
        name: "worldAddress",
      },
    ],
  },
  {
    name: "WorldConsumer_ValueNotAllowed",
    type: "error",
    inputs: [
      {
        type: "address",
        name: "worldAddress",
      },
    ],
  },
  {
    name: "Approval",
    type: "event",
    inputs: [
      {
        type: "address",
        name: "owner",
        indexed: true,
      },
      {
        type: "address",
        name: "spender",
        indexed: true,
      },
      {
        type: "uint256",
        name: "value",
      },
    ],
  },
  {
    name: "Transfer",
    type: "event",
    inputs: [
      {
        type: "address",
        name: "from",
        indexed: true,
      },
      {
        type: "address",
        name: "to",
        indexed: true,
      },
      {
        type: "uint256",
        name: "value",
      },
    ],
  },
  {
    name: "_msgSender",
    type: "function",
    stateMutability: "view",
    inputs: [],
    outputs: [
      {
        type: "address",
      },
    ],
  },
  {
    name: "_msgValue",
    type: "function",
    stateMutability: "view",
    inputs: [],
    outputs: [
      {
        type: "uint256",
      },
    ],
  },
  {
    name: "allowance",
    type: "function",
    stateMutability: "view",
    inputs: [
      {
        type: "address",
        name: "owner",
      },
      {
        type: "address",
        name: "spender",
      },
    ],
    outputs: [
      {
        type: "uint256",
      },
    ],
  },
  {
    name: "approve",
    type: "function",
    stateMutability: "nonpayable",
    inputs: [
      {
        type: "address",
        name: "spender",
      },
      {
        type: "uint256",
        name: "value",
      },
    ],
    outputs: [
      {
        type: "bool",
      },
    ],
  },
  {
    name: "balanceOf",
    type: "function",
    stateMutability: "view",
    inputs: [
      {
        type: "address",
        name: "account",
      },
    ],
    outputs: [
      {
        type: "uint256",
      },
    ],
  },
  {
    name: "burn",
    type: "function",
    stateMutability: "nonpayable",
    inputs: [
      {
        type: "uint256",
        name: "value",
      },
    ],
    outputs: [],
  },
  {
    name: "burnFrom",
    type: "function",
    stateMutability: "nonpayable",
    inputs: [
      {
        type: "address",
        name: "account",
      },
      {
        type: "uint256",
        name: "value",
      },
    ],
    outputs: [],
  },
  {
    name: "decimals",
    type: "function",
    stateMutability: "pure",
    inputs: [],
    outputs: [
      {
        type: "uint8",
      },
    ],
  },
  {
    name: "forceTransferFrom",
    type: "function",
    stateMutability: "nonpayable",
    inputs: [
      {
        type: "address",
        name: "from",
      },
      {
        type: "address",
        name: "to",
      },
      {
        type: "uint256",
        name: "value",
      },
    ],
    outputs: [],
  },
  {
    name: "mint",
    type: "function",
    stateMutability: "nonpayable",
    inputs: [
      {
        type: "address",
        name: "account",
      },
      {
        type: "uint256",
        name: "value",
      },
    ],
    outputs: [],
  },
  {
    name: "name",
    type: "function",
    stateMutability: "pure",
    inputs: [],
    outputs: [
      {
        type: "string",
      },
    ],
  },
  {
    name: "symbol",
    type: "function",
    stateMutability: "pure",
    inputs: [],
    outputs: [
      {
        type: "string",
      },
    ],
  },
  {
    name: "totalSupply",
    type: "function",
    stateMutability: "view",
    inputs: [],
    outputs: [
      {
        type: "uint256",
      },
    ],
  },
  {
    name: "transfer",
    type: "function",
    stateMutability: "nonpayable",
    inputs: [
      {
        type: "address",
        name: "to",
      },
      {
        type: "uint256",
        name: "value",
      },
    ],
    outputs: [
      {
        type: "bool",
      },
    ],
  },
  {
    name: "transferFrom",
    type: "function",
    stateMutability: "nonpayable",
    inputs: [
      {
        type: "address",
        name: "from",
      },
      {
        type: "address",
        name: "to",
      },
      {
        type: "uint256",
        name: "value",
      },
    ],
    outputs: [
      {
        type: "bool",
      },
    ],
  },
  {
    name: "newAccessGroup",
    type: "function",
    stateMutability: "nonpayable",
    inputs: [
      {
        type: "bytes32",
        name: "owner",
      },
    ],
    outputs: [
      {
        type: "uint256",
      },
    ],
  },
  {
    name: "setAccessGroup",
    type: "function",
    stateMutability: "nonpayable",
    inputs: [
      {
        type: "bytes32",
        name: "caller",
      },
      {
        type: "address",
        name: "groupOwner",
      },
    ],
    outputs: [],
  },
  {
    name: "setAccessGroup",
    type: "function",
    stateMutability: "nonpayable",
    inputs: [
      {
        type: "bytes32",
        name: "caller",
      },
      {
        type: "bytes32",
        name: "target",
      },
      {
        type: "uint256",
        name: "groupId",
      },
    ],
    outputs: [],
  },
  {
    name: "setAccessGroup",
    type: "function",
    stateMutability: "nonpayable",
    inputs: [
      {
        type: "bytes32",
        name: "target",
      },
      {
        type: "uint256",
        name: "groupId",
      },
    ],
    outputs: [],
  },
  {
    name: "setMembership",
    type: "function",
    stateMutability: "nonpayable",
    inputs: [
      {
        type: "bytes32",
        name: "caller",
      },
      {
        type: "bytes32",
        name: "target",
      },
      {
        type: "address",
        name: "member",
      },
      {
        type: "bool",
        name: "allowed",
      },
    ],
    outputs: [],
  },
  {
    name: "setMembership",
    type: "function",
    stateMutability: "nonpayable",
    inputs: [
      {
        type: "bytes32",
        name: "caller",
      },
      {
        type: "bytes32",
        name: "target",
      },
      {
        type: "bytes32",
        name: "member",
      },
      {
        type: "bool",
        name: "allowed",
      },
    ],
    outputs: [],
  },
  {
    name: "setMembership",
    type: "function",
    stateMutability: "nonpayable",
    inputs: [
      {
        type: "bytes32",
        name: "caller",
      },
      {
        type: "uint256",
        name: "groupId",
      },
      {
        type: "address",
        name: "member",
      },
      {
        type: "bool",
        name: "allowed",
      },
    ],
    outputs: [],
  },
  {
    name: "setMembership",
    type: "function",
    stateMutability: "nonpayable",
    inputs: [
      {
        type: "bytes32",
        name: "caller",
      },
      {
        type: "uint256",
        name: "groupId",
      },
      {
        type: "bytes32",
        name: "member",
      },
      {
        type: "bool",
        name: "allowed",
      },
    ],
    outputs: [],
  },
  {
    name: "setMembership",
    type: "function",
    stateMutability: "nonpayable",
    inputs: [
      {
        type: "bytes32",
        name: "target",
      },
      {
        type: "address",
        name: "member",
      },
      {
        type: "bool",
        name: "allowed",
      },
    ],
    outputs: [],
  },
  {
    name: "setMembership",
    type: "function",
    stateMutability: "nonpayable",
    inputs: [
      {
        type: "bytes32",
        name: "target",
      },
      {
        type: "bytes32",
        name: "member",
      },
      {
        type: "bool",
        name: "allowed",
      },
    ],
    outputs: [],
  },
  {
    name: "setMembership",
    type: "function",
    stateMutability: "nonpayable",
    inputs: [
      {
        type: "uint256",
        name: "groupId",
      },
      {
        type: "address",
        name: "member",
      },
      {
        type: "bool",
        name: "allowed",
      },
    ],
    outputs: [],
  },
  {
    name: "setMembership",
    type: "function",
    stateMutability: "nonpayable",
    inputs: [
      {
        type: "uint256",
        name: "groupId",
      },
      {
        type: "bytes32",
        name: "member",
      },
      {
        type: "bool",
        name: "allowed",
      },
    ],
    outputs: [],
  },
  {
    name: "setOwner",
    type: "function",
    stateMutability: "nonpayable",
    inputs: [
      {
        type: "bytes32",
        name: "caller",
      },
      {
        type: "uint256",
        name: "groupId",
      },
      {
        type: "bytes32",
        name: "newOwner",
      },
    ],
    outputs: [],
  },
  {
    name: "setOwner",
    type: "function",
    stateMutability: "nonpayable",
    inputs: [
      {
        type: "uint256",
        name: "groupId",
      },
      {
        type: "bytes32",
        name: "newOwner",
      },
    ],
    outputs: [],
  },
  {
    name: "setTextSignContent",
    type: "function",
    stateMutability: "nonpayable",
    inputs: [
      {
        type: "bytes32",
        name: "caller",
      },
      {
        type: "bytes32",
        name: "target",
      },
      {
        type: "string",
        name: "content",
      },
    ],
    outputs: [],
  },
  {
    name: "setTextSignContent",
    type: "function",
    stateMutability: "nonpayable",
    inputs: [
      {
        type: "bytes32",
        name: "target",
      },
      {
        type: "string",
        name: "content",
      },
    ],
    outputs: [],
  },
  {
    name: "grantAccess",
    type: "function",
    stateMutability: "nonpayable",
    inputs: [
      {
        type: "bytes32",
      },
      {
        type: "address",
      },
    ],
    outputs: [],
  },
  {
    name: "revokeAccess",
    type: "function",
    stateMutability: "nonpayable",
    inputs: [
      {
        type: "bytes32",
      },
      {
        type: "address",
      },
    ],
    outputs: [],
  },
  {
    name: "transferOwnership",
    type: "function",
    stateMutability: "nonpayable",
    inputs: [
      {
        type: "bytes32",
      },
      {
        type: "address",
      },
    ],
    outputs: [],
  },
  {
    name: "renounceOwnership",
    type: "function",
    stateMutability: "nonpayable",
    inputs: [
      {
        type: "bytes32",
      },
    ],
    outputs: [],
  },
  {
    name: "transferBalanceToNamespace",
    type: "function",
    stateMutability: "nonpayable",
    inputs: [
      {
        type: "bytes32",
      },
      {
        type: "bytes32",
      },
      {
        type: "uint256",
      },
    ],
    outputs: [],
  },
  {
    name: "transferBalanceToAddress",
    type: "function",
    stateMutability: "nonpayable",
    inputs: [
      {
        type: "bytes32",
      },
      {
        type: "address",
      },
      {
        type: "uint256",
      },
    ],
    outputs: [],
  },
  {
    name: "batchCall",
    type: "function",
    stateMutability: "nonpayable",
    inputs: [
      {
        type: "tuple[]",
        components: [
          {
            type: "bytes32",
          },
          {
            type: "bytes",
          },
        ],
      },
    ],
    outputs: [],
  },
  {
    name: "batchCallFrom",
    type: "function",
    stateMutability: "nonpayable",
    inputs: [
      {
        type: "tuple[]",
        components: [
          {
            type: "address",
          },
          {
            type: "bytes32",
          },
          {
            type: "bytes",
          },
        ],
      },
    ],
    outputs: [],
  },
  {
    name: "installModule",
    type: "function",
    stateMutability: "nonpayable",
    inputs: [
      {
        type: "address",
      },
      {
        type: "bytes",
      },
    ],
    outputs: [],
  },
  {
    name: "registerTable",
    type: "function",
    stateMutability: "nonpayable",
    inputs: [
      {
        type: "bytes32",
      },
      {
        type: "bytes32",
      },
      {
        type: "bytes32",
      },
      {
        type: "bytes32",
      },
      {
        type: "string[]",
      },
      {
        type: "string[]",
      },
    ],
    outputs: [],
  },
  {
    name: "registerStoreHook",
    type: "function",
    stateMutability: "nonpayable",
    inputs: [
      {
        type: "bytes32",
      },
      {
        type: "address",
      },
      {
        type: "uint8",
      },
    ],
    outputs: [],
  },
  {
    name: "unregisterStoreHook",
    type: "function",
    stateMutability: "nonpayable",
    inputs: [
      {
        type: "bytes32",
      },
      {
        type: "address",
      },
    ],
    outputs: [],
  },
  {
    name: "registerNamespace",
    type: "function",
    stateMutability: "nonpayable",
    inputs: [
      {
        type: "bytes32",
      },
    ],
    outputs: [],
  },
  {
    name: "registerSystemHook",
    type: "function",
    stateMutability: "nonpayable",
    inputs: [
      {
        type: "bytes32",
      },
      {
        type: "address",
      },
      {
        type: "uint8",
      },
    ],
    outputs: [],
  },
  {
    name: "unregisterSystemHook",
    type: "function",
    stateMutability: "nonpayable",
    inputs: [
      {
        type: "bytes32",
      },
      {
        type: "address",
      },
    ],
    outputs: [],
  },
  {
    name: "registerSystem",
    type: "function",
    stateMutability: "nonpayable",
    inputs: [
      {
        type: "bytes32",
      },
      {
        type: "address",
      },
      {
        type: "bool",
      },
    ],
    outputs: [],
  },
  {
    name: "registerFunctionSelector",
    type: "function",
    stateMutability: "nonpayable",
    inputs: [
      {
        type: "bytes32",
      },
      {
        type: "string",
      },
    ],
    outputs: [],
  },
  {
    name: "registerRootFunctionSelector",
    type: "function",
    stateMutability: "nonpayable",
    inputs: [
      {
        type: "bytes32",
      },
      {
        type: "string",
      },
      {
        type: "string",
      },
    ],
    outputs: [],
  },
  {
    name: "registerDelegation",
    type: "function",
    stateMutability: "nonpayable",
    inputs: [
      {
        type: "address",
      },
      {
        type: "bytes32",
      },
      {
        type: "bytes",
      },
    ],
    outputs: [],
  },
  {
    name: "unregisterDelegation",
    type: "function",
    stateMutability: "nonpayable",
    inputs: [
      {
        type: "address",
      },
    ],
    outputs: [],
  },
  {
    name: "registerNamespaceDelegation",
    type: "function",
    stateMutability: "nonpayable",
    inputs: [
      {
        type: "bytes32",
      },
      {
        type: "bytes32",
      },
      {
        type: "bytes",
      },
    ],
    outputs: [],
  },
  {
    name: "unregisterNamespaceDelegation",
    type: "function",
    stateMutability: "nonpayable",
    inputs: [
      {
        type: "bytes32",
      },
    ],
    outputs: [],
  },
  {
    name: "callWithSignature",
    type: "function",
    stateMutability: "nonpayable",
    inputs: [
      {
        type: "address",
      },
      {
        type: "bytes32",
      },
      {
        type: "bytes",
      },
      {
        type: "bytes",
      },
    ],
    outputs: [],
  },
  {
    name: "getResourceTag",
    type: "function",
    stateMutability: "nonpayable",
    inputs: [
      {
        type: "bytes32",
      },
      {
        type: "bytes32",
      },
    ],
    outputs: [],
  },
  {
    name: "setResourceTag",
    type: "function",
    stateMutability: "nonpayable",
    inputs: [
      {
        type: "bytes32",
      },
      {
        type: "bytes32",
      },
      {
        type: "bytes",
      },
    ],
    outputs: [],
  },
  {
    name: "deleteResourceTag",
    type: "function",
    stateMutability: "nonpayable",
    inputs: [
      {
        type: "bytes32",
      },
      {
        type: "bytes32",
      },
    ],
    outputs: [],
  },
] as const;

export const abi = [...worldAbi, ...systemAbis] as const;
